module.exports = __webpack_public_path__ + "static/media/retroJS.99679009.png";